import { Icon } from '@iconify/react';
import { useEffect, useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography, Avatar, IconButton } from '@mui/material';
// components
import { connect } from 'react-redux';
import MenuPopover from '../../components/MenuPopover';
//
import account from '../../_mocks_/account';
import { Loading } from '../../components/Loading';
import { fUserRole } from '../../utils/formatEnums';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: homeFill,
    linkTo: '/'
  },
  {
    label: 'Profile',
    icon: personFill,
    linkTo: '#'
  },
  {
    label: 'Settings',
    icon: settings2Fill,
    linkTo: '#'
  }
];

// ----------------------------------------------------------------------

const AccountPopover = ({ logout, fetchProfile, loading, profile, currentRole }) => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  console.log('profile: ', profile);
  console.log('loading: ', loading);

  return (
    <>
      {/* <Box sx={{ mb: 5, mx: 2.5 }}> */}
      {/*  <Link underline="none" component={RouterLink} to="#"> */}
      {/*    <AccountStyle> */}
      <Box>
        {loading || !profile ? (
          <Loading />
        ) : (
          <>
            <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
              {profile.firstName} {profile.lastName}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {fUserRole(currentRole)}
            </Typography>
          </>
        )}
      </Box>
      {/*    </AccountStyle> */}
      {/*  </Link> */}
      {/* </Box> */}
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar src={account.photoURL} alt="photoURL" />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {loading || !profile ? <Loading /> : `${profile.firstName} ${profile.lastName}`}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {loading || !profile ? <Loading /> : profile.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* {MENU_OPTIONS.map((option) => ( */}
        {/*  <MenuItem */}
        {/*    key={option.label} */}
        {/*    to={option.linkTo} */}
        {/*    component={RouterLink} */}
        {/*    onClick={handleClose} */}
        {/*    sx={{ typography: 'body2', py: 1, px: 2.5 }} */}
        {/*  > */}
        {/*    <Box */}
        {/*      component={Icon} */}
        {/*      icon={option.icon} */}
        {/*      sx={{ */}
        {/*        mr: 2, */}
        {/*        width: 24, */}
        {/*        height: 24 */}
        {/*      }} */}
        {/*    /> */}

        {/*    {option.label} */}
        {/*  </MenuItem> */}
        {/* ))} */}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth color="inherit" variant="outlined" onClick={logout}>
            Cerrar sesión
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
};

const mapState = (state) => ({
  profile: state.auth.profile,
  loading: state.loading.effects.auth.fetchProfile.loading,
  currentRole: state.property.currentRole
});

const mapDispatch = (dispatch) => ({
  logout: dispatch.auth.logout,
  fetchProfile: dispatch.auth.fetchProfile
});

export default connect(mapState, mapDispatch)(AccountPopover);
